import ReportChart from "./ReportChart";
import NoData from "../NoData";
import { VictoryStack, VictoryLabel, VictoryBar, VictoryLegend } from "victory";
import { extendedColors } from "../ReportsHelper";
import { ReportChartConsts } from "../ReportTooltips";

export default function NbusBySegmentChart({ data, lob }) {
    const labelColor = document.documentElement.getAttribute('data-gdstheme') === 'dark' ? "#ffffff" : "#000000";
    const noData = !data?.some(group => group.Data?.NewBusiness > 0);

    if (noData) return (
        <ReportChart {...ReportChartConsts(lob === 'ppa' ? 'ppaNbusBySegment' : 'commercialNbusBySegment')} stacked>
            <NoData />
        </ReportChart>
    );

    data = data?.filter(d => d.GroupingKey != null && d.Data.NewBusiness > 0);
    const sum = data?.reduce((acc, d) => acc + d.Data.NewBusiness, 0);

    const ppaSegmentMapper = (key) => ({
        'B': 'Preferred',
        'C': 'Standard',
        'D': 'Non-Standard'
    }[key] || key);

    return (
        <ReportChart {...ReportChartConsts(lob === 'ppa' ? 'ppaNbusBySegment' : 'commercialNbusBySegment')} stacked>
            <>
                <VictoryLegend
                    height={50}
                    orientation="horizontal"
                    itemsPerRow={lob === "ppa" ? 5 : 3}
                    gutter={15}
                    data={data.map((d, index) => ({
                        name: lob === "ppa" ? ppaSegmentMapper(d.GroupingKey) : d.GroupingKey,
                        symbol: { fill: extendedColors[index] }
                    }))}
                    style={{ labels: { fontSize: 12, fill: labelColor } }}
                />
                <VictoryStack
                    colorScale={"blue"}
                    height={100}
                >
                    {data.map((d, index) => (
                        <VictoryBar
                            horizontal
                            key={index}
                            data={[d.Data.NewBusiness]}
                            barWidth={50}
                            style={{ data: { fill: extendedColors[index] } }}
                            labels={`${(d.Data.NewBusiness / sum * 100).toFixed(0)}%`}
                            labelComponent={
                                <VictoryLabel
                                    dy={-40}
                                    dx={-(d.Data.NewBusiness / sum) * 200}
                                    style={{ fill: labelColor }}
                                />
                            }
                        />
                    ))}
                </VictoryStack>
            </>
        </ReportChart >
    )
}